export default __webpack_public_path__ + "static/media/loading-skull-noun.b0631e61.gif";